export default __webpack_public_path__ + "static/media/slot-banners-cn.838b6ed5.webp";